module.exports = __webpack_public_path__ + "static/media/homepage_atf_2_mo.c672636a.png";